import Content from "./Content";
import Header from "./Header";
import Footer from "./Footer";
export default function App() {
  return (
    <>
      <Header />
      <Content />
      <Footer />
    </>
  );
}
